import type { AlaCarteContent, AlaCarteItem, AlaCarteSection } from '@core/interfaces/api';

export function newId() {
  return globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export const EMPTY_CONTENT: AlaCarteContent = { leftColumn: [], rightColumn: [] };

export function emptySection(): AlaCarteSection {
  return { id: newId(), header: '', items: [] };
}

export function emptyItem(withDescription = false): AlaCarteItem {
  return { id: newId(), name: '', description: withDescription ? '' : undefined };
}

export function cloneContent(c: AlaCarteContent): AlaCarteContent {
  return JSON.parse(JSON.stringify(c));
}

/** Normalize saved data — guards against older formats where sections may be empty arrays or missing fields. */
export function normalizeContent(c: AlaCarteContent): AlaCarteContent {
  const fix = (sections: unknown[]) =>
    (sections ?? [])
      .filter((s): s is Record<string, unknown> => !!s && typeof s === 'object' && !Array.isArray(s))
      .map((s) => ({
        id: (s.id as string) || newId(),
        header: (s.header as string) ?? '',
        items: (Array.isArray(s.items) ? s.items : []).map((item: any) => ({
          id: item?.id || newId(),
          name: item?.name ?? '',
          ...(item?.description !== undefined && item?.description !== null
            ? { description: item.description }
            : {}),
        })),
      }));
  return { ...c, leftColumn: fix(c.leftColumn as unknown[]), rightColumn: fix(c.rightColumn as unknown[]) };
}
